<template>
    <div
        class="feature-flag"
        :class="{
            [display]: display,
            enabled: isFeatureFlagEnabled,
            disabled: !isFeatureFlagEnabled,
        }"
        :style="{ flexGrow: grow, marginRight: margin, maxWidth: width }"
        v-if="!isLoading && (isFeatureFlagEnabled || allowDisabled)"
    >
        <slot v-if="isFeatureFlagEnabled"></slot>
        <slot name="enabled" v-if="isFeatureFlagEnabled"></slot>
        <slot name="disabled" v-if="!isFeatureFlagEnabled"></slot>
    </div>
</template>
<script>

import { featureFlagService } from '@/services';

export default {
    name: 'feature-flag',
    props: {
        allowDisabled: {
            type: Boolean,
            default: false,
        },
        display: {
            type: String,
            validator: value => ['inline', 'inline-block'].includes(value),
        },
        grow: {
            type: [String, Number],
        },
        margin: {
            type: String,
        },
        name: {
            required: true,
            type: String,
        },
        params: {
            type: Object,
        },
        width: {
            type: String,
        },
    },
    data() {
        return {
            isFeatureFlagEnabled: false,
            isLoading: true,
        };
    },
    async mounted() {
        const { name, params } = this;
        if (name === 'domainMetrics' || name === 'taskListPartition' || name === 'taskListMetrics') {
            this.isFeatureFlagEnabled = false;
            this.isLoading = false;
        } else if (name === 'workflowGraph') {
            this.isFeatureFlagEnabled = true;
            this.isLoading = false;
        } else {
            const res = await featureFlagService.isFeatureFlagEnabled({
                name,
                params,
            })
            this.isFeatureFlagEnabled = res.data.value;
            this.isLoading = false;
        }
    },
};
</script>


<style lang="stylus">
.feature-flag {
  &.inline {
    display: inline;
  }
  &.inline-block {
    display: inline-block;
  }
}
</style>
